import React from "react";
import { connect } from "react-redux";
import { AppState, store } from "../../../redux";
import $ from "jquery";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import "./getting-started.scss";
import BulletPoints from "./bullet-points";
import HowTo from "./how-to-videos";
import AmplifySuccess from "./amplify-success";
import FAQ from "./faq";
import Members from "./members";
import { Header } from "./header";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const GettingStartedComponent = (props: Props) => {
  React.useEffect(() => {
    $("body").addClass("allow-scroll");
  });

  return (
    <Container>
      <Header />
      <Members />
      {/* <BulletPoints /> */}
      <HowTo />
      <AmplifySuccess />
      <FAQ />
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => (
  <div className="getting-started">
    <div className="getting-started-container">{children}</div>
  </div>
);

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};
export const GettingStarted = connect(mapState, mapDispatch)(GettingStartedComponent);
